import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Cause } from "types";
import { fetchAllCauses } from "./causes.actions";
import { initialState } from "./causes.initial-state";


const causesSlice = createSlice({
  name: "causes",
  initialState,
  reducers: {
    setAllCauses: (state, action: PayloadAction<Cause[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCauses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCauses.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchAllCauses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch campaign";
      })
  },
});

export const { setAllCauses } = causesSlice.actions;
const causesReducer = causesSlice.reducer;
export default causesReducer;
